const mapboxgl = require("mapbox-gl");
const segmentInsert = require("@mapbox/segmentio-insert");
const d3 = require("d3");
const al092017_pts = require("./data/best_track/geojson/al092017/AL092017_pts.json");
const al112017_pts = require("./data/best_track/geojson/al112017/AL112017_pts.json");
const al122017_pts = require("./data/best_track/geojson/al122017/AL122017_pts.json");
const al152017_pts = require("./data/best_track/geojson/al152017/AL152017_pts.json");
const al092017_windswath = require("./data/best_track/geojson/al092017/AL092017_windswath.json");
const al112017_windswath = require("./data/best_track/geojson/al112017/AL112017_windswath.json");
const al122017_windswath = require("./data/best_track/geojson/al122017/AL122017_windswath.json");
const al152017_windswath = require("./data/best_track/geojson/al152017/AL152017_windswath.json");

mapboxgl.accessToken = "pk.eyJ1IjoibGFicy1zYW5kYm94IiwiYSI6ImNrMTZuanRhajE3bWYzbXRrcWQ5ZWc3bGkifQ.uF2Y11fRJRRGb4Va2uy_Fg";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", { name: "hurricanes" });

const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/mapbox/light-v9",
  center: [-69.876236, 27.690419],
  zoom: 3
});

const catColors = {
  0: "#ccc",
  1: "#ffbd68",
  2: "#fc8d59",
  3: "#ef6548",
  4: "#d7301f",
  5: "#7f0000"
};

const svg = d3.select("svg");

const color = d3.scaleThreshold()
  .domain([0, 1, 2, 3, 4, 5])
  .range(Object.values(catColors));

const x = d3.scaleLinear()
  .domain([-1, 0, 1, 2, 3, 4, 5, 6])
  .rangeRound([0, 50]);

const g = svg.append("g")
  .attr("class", "key")
  .attr("transform", "translate(10,30)");

g.selectAll("rect")
  .data(color.range().map(d => {
    d = color.invertExtent(d);
    if (d[0] == null) d[0] = x.domain()[0];
    if (d[1] == null) d[1] = x.domain()[1];
    return d;
  }))
  .enter().append("rect")
  .attr("height", 13)
  .attr("x", d => {
    return x(d[0]);
  })
  .attr("width", d => {
    return x(d[1]) - x(d[0]);
  })
  .attr("fill", d => {
    return color(d[0]);
  });

g.append("text")
  .attr("class", "caption")
  .attr("x", x.range()[0])
  .attr("y", -8)
  .attr("fill", "#000")
  .attr("text-anchor", "start")
  .text("Storm category");

g.call(d3.axisBottom(x)
  .tickSize(13)
  .tickFormat(d3.format(",.0f"))
  .tickValues(color.domain()))
  .select(".domain")
  .remove();

const g1 = svg.append("g")
  .attr("class", "key2")
  .attr("transform", "translate(10,100)");

g1.selectAll("rect")
  .data(color.range().map(d => {
    d = color.invertExtent(d);
    if (d[0] == null) d[0] = x.domain()[0];
    if (d[1] == null) d[1] = x.domain()[1];
    return d;
  }))
  .enter().append("rect")
  .attr("height", 13)
  .attr("x", d => {
    return x(d[0]);
  })
  .attr("width", d => {
    return x(d[1]) - x(d[0]);
  })
  .attr("fill", d => {
    return color(d[0]);
  });

g1.append("text")
  .attr("class", "caption")
  .attr("x", x.range()[0])
  .attr("y", -8)
  .attr("fill", "#000")
  .attr("text-anchor", "start")
  .text("Wind speed");

const speeds = ["", "> 39 mph", "> 58 mph", "> 74 mph"];

g1.call(d3.axisBottom(x)
  .tickSize(13)
  .tickFormat(d => {
    return speeds[d];
  })
  .tickValues(color.domain()))
  .select(".domain")
  .remove();

d3.selectAll(".key .tick text").attr("transform", "translate(-25,5)");
d3.selectAll(".key2 .tick text").attr("transform", "translate(-50,5)");

d3.select("g.tick text").text("TS");

const pointDict = {
  "harvey": {
    "points": [],
    "wind": []
  },
  "irma": {
    "points": [],
    "wind": []
  },
  "jose": {
    "points": [],
    "wind": []
  },
  "maria": {
    "points": [],
    "wind": []
  }
};

// all points and lines are on top since windswaths are being
// placed and colored before the points are added
function addPoints(name){
  const points = pointDict[name]["points"];
  map.on("load", () => {
    map.addSource(name + "_pts", {
      type: "geojson",
      data: points
    });

    const lines = [];

    points.features.forEach((feature, i) => {
      const cat = feature.properties["SS"];

      // create lines so that they can be colored
      if (i < points.features.length - 1){
        const line = {
          "type": "Feature",
          "properties": {
            "color": cat
          },
          "geometry": {
            "type": "LineString",
            "coordinates": [
              points.features[i]["geometry"]["coordinates"],
              points.features[i + 1]["geometry"]["coordinates"]
            ]
          }
        };
        lines.push(line);
      }

    });

    const lineGeo = {
      "type": "FeatureCollection",
      "features": lines
    };

    map.addSource(name + "_lines", {
      type: "geojson",
      data: lineGeo
    });

    // add lines between points
    map.addLayer({
      "id": name + "_lines_layer",
      "type": "line",
      "source": name + "_lines",
      "layout": {
        "line-join": "round",
        "line-cap": "round"
      },
      "paint": {
        "line-color": {
          "property": "color",
          "type": "categorical",
          "stops": [
            [0, "#ccc"],
            [1, "#ffbd68"],
            [2, "#fc8d59"],
            [3, "#ef6548"],
            [4, "#d7301f"],
            [5, "#7f0000"]
          ]
        },
        "line-width": {
          "base": 1.75,
          "stops": [[2, 1.5], [10, 40]]
        }
      }
    }, "place-city-sm");

    // add points for hurricanes
    map.addLayer({
      "id": name + "_pts_layer",
      "type": "circle",
      "source": name + "_pts",
      "paint": {
        "circle-radius": {
          "base": 1.75,
          "stops": [[2, 2], [10, 60]]
        },
        "circle-color": {
          "property": "SS",
          "type": "categorical",
          "stops": [
            [0.0, "#ccc"],
            [1.0, "#ffbd68"],
            [2.0, "#fc8d59"],
            [3.0, "#ef6548"],
            [4.0, "#d7301f"],
            [5.0, "#7f0000"]
          ]
        },
        "circle-stroke-color": "#fff",
        "circle-stroke-width": {
          "base": .3,
          "stops": [[2, .3], [10, 1]]
        }
      }
    }, "place-city-sm");

    // add storm name
    map.addLayer({
      "id": name + "_stormname",
      "type": "symbol",
      "source": {
        "type": "geojson",
        "data": {
          "type": "Feature",
          "properties": {
            "STORMNAME": points.features[points.features.length - 1]["properties"]["STORMNAME"]
          },
          "geometry": {
            "type": "Point",
            "coordinates": points.features[points.features.length - 1]["geometry"]["coordinates"]
          }
        }
      },
      "layout": {
        "text-field": "{STORMNAME}",
        "text-font": ["Open Sans Regular", "Arial Unicode MS Regular"],
        "text-offset": [0, -0.3],
        "text-anchor": "bottom"
      },
      "paint": {
        "text-halo-color": "#ffffff",
        "text-halo-width": 1
      }
    });

    // add date and time
    map.addLayer({
      "id": name + "_text",
      "type": "symbol",
      "source": name + "_pts",
      "layout": {
        "text-field": "{MONTH} {DAY}, {HHMM}",
        "text-font": ["Open Sans Regular", "Arial Unicode MS Regular"],
        "text-offset": [0.5, 0],
        "text-anchor": "left",
        "text-size": 15
      },
      "paint": {
        "text-halo-color": "#ffffff",
        "text-halo-width": 1,
        "text-opacity": 0
      }
    });

  });
}

function renderPoints(al09, al11, al12, al15){
  pointDict["harvey"]["points"] = al09;
  pointDict["irma"]["points"] = al11;
  pointDict["jose"]["points"] = al12;
  pointDict["maria"]["points"] = al15;
  addPoints("harvey");
  addPoints("irma");
  addPoints("jose");
  addPoints("maria");
}

function addWind(name){
  const wind = pointDict[name]["wind"];
  map.on("load", () => {
    map.addSource(name + "_wind", {
      type: "geojson",
      data: wind
    });

    map.addLayer({
      "id": name + "_wind_layer",
      "type": "fill",
      "source": name + "_wind",
      "paint": {
        "fill-color": {
          "property": "RADII",
          "type": "categorical",
          "stops": [
            [34, "#dddddd"],
            [50, "#ffd9a8"],
            [64, "#ffbd68"]
          ]
        },
        "fill-opacity": 0.7
      }
    }, "place-city-sm");

  });
}

function renderWind(al09, al11, al12, al15){
  pointDict["harvey"]["wind"] = al09;
  pointDict["irma"]["wind"] = al11;
  pointDict["jose"]["wind"] = al12;
  pointDict["maria"]["wind"] = al15;
  addWind("harvey");
  addWind("irma");
  addWind("jose");
  addWind("maria");
  renderPoints(al092017_pts, al112017_pts, al122017_pts, al152017_pts);
}

function makeOpaque(){
  const hNames = ["harvey", "irma", "jose", "maria"];
  for (let i = 0; i < hNames.length; i++){
    map.setPaintProperty(hNames[i] + "_pts_layer", "circle-opacity", 1);
    map.setPaintProperty(hNames[i] + "_pts_layer", "circle-stroke-opacity", 1);
    map.setPaintProperty(hNames[i] + "_lines_layer", "line-opacity", 1);
    map.setPaintProperty(hNames[i] + "_wind_layer", "fill-opacity", 0.9);
    map.setPaintProperty(hNames[i] + "_stormname", "text-opacity", 1);
    map.setPaintProperty(hNames[i] + "_text", "text-opacity", 0);
  }
}

map.on("mousemove", e => {
  const features = map.queryRenderedFeatures(e.point);
  const hNames = ["harvey", "irma", "jose", "maria"];
  if (features[0]){
    const name = features[0]["layer"]["id"].split("_")[0];
    const idx = hNames.indexOf(name);
    if (idx > -1){
      hNames.splice(idx, 1);
      makeOpaque();
      map.setPaintProperty(name + "_text", "text-opacity", 1);
      for (let i = 0; i < hNames.length; i++){
        map.setPaintProperty(hNames[i] + "_pts_layer", "circle-opacity", 0.2);
        map.setPaintProperty(hNames[i] + "_pts_layer", "circle-stroke-opacity", 0.2);
        map.setPaintProperty(hNames[i] + "_lines_layer", "line-opacity", 0.2);
        map.setPaintProperty(hNames[i] + "_wind_layer", "fill-opacity", 0.3);
        map.setPaintProperty(hNames[i] + "_stormname", "text-opacity", 0.5);
        map.setPaintProperty(hNames[i] + "_text", "text-opacity", 0);
      }
    } else {
      makeOpaque();
    }
  }

});


renderWind(al092017_windswath, al112017_windswath, al122017_windswath, al152017_windswath);
